import { Button, Grid, Typography } from '@material-ui/core';
import { Formik } from 'formik';
import React from 'react';
import {
  ResponsiveCard,
  ResponsiveCardActions,
  ResponsiveCardContent,
} from '../../../../../../common/components/cards';
import { PasswordTextField } from '../../../../../../common/components/fields';
import { CenterAlign } from '../../../../../../common/components/layout';
import Logo from '../../../../../../common/components/Logo';
import {
  resetPasswordInit,
  resetPasswordValidationSchema,
} from '../../../../groupVisits.dtos';

interface Props {
  onResetPassword: (values: any) => void;
}

const GroupVisitChangePassword: React.FC<Props> = ({ onResetPassword }) => {
  return (
    <CenterAlign>
      <ResponsiveCard>
        <Logo />
        <Formik
          initialValues={resetPasswordInit}
          validateOnChange={false}
          validationSchema={resetPasswordValidationSchema}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              console.log(values);
              setTimeout(() => {
                setSubmitting(false);
              }, 700);

              onResetPassword(values);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
          }) => {
            return (
              <form
                onSubmit={(e) => {
                  handleSubmit();
                  e.preventDefault();
                }}
                noValidate
              >
                <ResponsiveCardContent>
                  <Typography variant='caption'>
                    Password must be 12 characters or longer with at least 1
                    uppercase letter, 1 lowercase letter, 1 number and 1 special
                    character.
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <PasswordTextField
                        label='Password'
                        fullWidth
                        name='password'
                        value={values.password}
                        onChange={handleChange}
                        error={Boolean(touched.password && errors.password)}
                        helperText={touched.password && errors.password}
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <PasswordTextField
                        label='Confirm password'
                        fullWidth
                        name='confirmPassword'
                        value={values.confirmPassword}
                        onChange={handleChange}
                        required
                        error={Boolean(errors.confirmPassword)}
                        helperText={errors.confirmPassword}
                      />
                    </Grid>
                  </Grid>
                </ResponsiveCardContent>

                <ResponsiveCardActions>
                  <Grid container justify='flex-end'>
                    <Button
                      color='primary'
                      variant='text'
                      disabled={
                        isSubmitting ||
                        (values.confirmPassword === '' &&
                          values.password === '')
                      }
                      type='submit'
                      data-cy='resetPassword'
                    >
                      DONE
                    </Button>
                  </Grid>
                </ResponsiveCardActions>
              </form>
            );
          }}
        </Formik>
      </ResponsiveCard>
    </CenterAlign>
  );
};

export default GroupVisitChangePassword;
